// 影视资讯模拟数据（前端静态演示）
export const newsList = [
  {
    id: "n-spring-market",
    title: "春季档电影市场观察：多类型影片同台竞技",
    category: "市场观察",
    summary: "今年春季档影片类型丰富，科幻、悬疑、动画与剧情片各占一席，观众的观影选择更加多元。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinema%20hall%20interior%20with%20glowing%20screen%20light%20and%20rows%20of%20seats%2C%20warm%20amber%20and%20deep%20blue%20palette%2C%20minimal%20editorial%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=news-spring-market-cover&orientation=landscape",
    author: "编辑部",
    source: "555电影网",
    date: "2026-04-02",
    views: 18420,
  paragraphs: [
    "随着天气回暖，春季档电影市场也逐渐升温。与往年相比，今年春季档的影片类型分布更加均衡，科幻、悬疑、动画与现实主义剧情片几乎平分秋色，为不同偏好的观众都提供了选择。",
    "业内人士分析认为，类型多元化是市场走向成熟的标志。过去几年，档期往往被单一题材主导，而今年观众可以在同一时段看到风格迥异的作品，这有助于分散档期压力，也让中小成本影片获得了更多曝光机会。",
    "从观众反馈来看，口碑与类型标签正在成为影响观影决策的关键因素。不少观众表示，他们更愿意根据评分和题材简介来选择影片，而不是单纯依赖宣传热度。",
    "可以预见，随着内容供给的持续丰富，未来的档期竞争将更多体现在内容品质与观众口碑上，而非仅靠排片与营销。",
  ],
  },
  {
    id: "n-deepsea-sequel",
    title: "《深海追光》宣布续作立项，主创团队回归",
    category: "项目动态",
    summary: "科幻影片《深海追光》确认开发续集，导演与主要演员将悉数回归，故事将走向更深的未知海域。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20deep%20ocean%20scene%20with%20glowing%20light%20beams%20and%20soft%20particles%2C%20deep%20teal%20and%20gold%20palette%2C%20minimal%20editorial%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=news-deepsea-sequel-cover&orientation=landscape",
    author: "编辑部",
    source: "555电影网",
    date: "2026-03-28",
    views: 26310,
  paragraphs: [
    "备受关注的科幻影片《深海追光》近日传出续作立项消息。据制作方透露，续集将继续由原班主创团队操刀，故事线索会从上一部结尾的悬念出发，走向更深、更未知的海域。",
    "导演陈默表示，第一部作品留下的想象空间很大，续集希望在保留原有世界观的同时，进一步探讨人与自然、未知与恐惧之间的关系。",
    "演员阵容方面，林嘉树、周予安、苏黎预计将悉数回归。制作方同时透露，续集在视觉呈现上会有全面升级，但依然会坚持「内容为王」的创作理念。",
    "目前影片处于前期筹备阶段，具体上映时间尚未公布。",
  ],
  },
  {
    id: "n-drama-review",
    title: "年度口碑剧集盘点：悬疑题材持续领跑",
    category: "盘点推荐",
    summary: "在过去一年中，悬疑类剧集凭借扎实的剧本与精巧的结构，成为口碑与讨论度双高的类型。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20television%20wall%20with%20soft%20glowing%20screens%20and%20reflections%2C%20moody%20slate%20blue%20and%20amber%20palette%2C%20minimal%20editorial%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=news-drama-review-cover&orientation=landscape",
    author: "编辑部",
    source: "555电影网",
    date: "2026-03-20",
    views: 15230,
  paragraphs: [
    "回顾过去一年，悬疑类剧集无疑是最受观众青睐的类型之一。从年代探案到都市犯罪，多部作品凭借扎实的剧本和精巧的叙事结构赢得了口碑。",
    "与以往不同的是，如今的悬疑作品更加注重人物塑造与情感深度，而不再仅仅依赖情节反转。观众在追查真相的同时，也能感受到角色的挣扎与成长。",
    "此外，制作水准的整体提升也功不可没。灯光、配乐与镜头语言的成熟，让剧集的沉浸感显著增强。",
    "可以预见，未来悬疑题材仍将是各大平台重点布局的方向，但如何在同质化竞争中脱颖而出，将考验创作者的功力。",
  ],
  },
  {
    id: "n-festival-award",
    title: "国际影展获奖名单揭晓，多部华语影片亮相",
    category: "影展资讯",
    summary: "本届国际影展公布了完整获奖名单，华语影片在多个单元获得提名与奖项，表现亮眼。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20film%20festival%20red%20carpet%20with%20golden%20light%20and%20bokeh%2C%20warm%20red%20and%20gold%20palette%2C%20minimal%20editorial%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=news-festival-award-cover&orientation=landscape",
    author: "编辑部",
    source: "555电影网",
    date: "2026-03-14",
    views: 11980,
  paragraphs: [
    "本届国际影展近日公布完整获奖名单，多部华语影片入围主竞赛与展映单元，并在表演、摄影等技术奖项上有所斩获。",
    "影评人指出，这批作品在题材选择上更加贴近现实，叙事方式也更为克制内敛，展现了中国电影人在国际化表达上的新探索。",
    "影展期间，多部影片还举办了主创见面会，与海外观众进行了深入交流。",
    "对于观众而言，影展既是一次观影盛宴，也是了解全球电影创作趋势的重要窗口。",
  ],
  },
  {
    id: "n-virtual-production",
    title: "影视行业技术升级：虚拟制片成为新趋势",
    category: "行业观察",
    summary: "越来越多剧组开始采用虚拟制片技术，在提升制作效率的同时，也为想象力打开了更大的空间。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20virtual%20production%20studio%20with%20glowing%20led%20walls%2C%20deep%20blue%20and%20cyan%20palette%2C%20minimal%20futuristic%20editorial%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=news-virtual-production-cover&orientation=landscape",
    author: "编辑部",
    source: "555电影网",
    date: "2026-03-08",
    views: 9640,
  paragraphs: [
    "虚拟制片正在成为影视行业的热门话题。通过在拍摄现场搭建 LED 幕墙与实时渲染引擎，剧组可以在镜头内直接呈现原本需要大量后期合成的场景。",
    "这一技术的最大优势在于「所见即所得」。演员能够直观地看到所处环境，表演更加自然；导演也能在现场即时调整构图与光线。",
    "当然，虚拟制片对前期筹备与美术设计提出了更高要求。业内人士认为，它并不会取代传统拍摄，而是为创作者提供了更多选择。",
    "随着硬件成本下降与流程标准化，虚拟制片有望在更多类型作品中得到应用。",
  ],
  },
  {
    id: "n-summer-animation",
    title: "暑期档前瞻：动画电影迎来创作高峰",
    category: "档期前瞻",
    summary: "多部动画电影定档暑期，从合家欢到奇幻冒险，题材覆盖广泛，市场竞争格外激烈。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20colorful%20animation%20scene%20with%20floating%20islands%20and%20soft%20clouds%2C%20pastel%20rainbow%20palette%2C%20minimal%20editorial%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=news-summer-animation-cover&orientation=landscape",
    author: "编辑部",
    source: "555电影网",
    date: "2026-03-01",
    views: 13720,
  paragraphs: [
    "随着暑期档临近，多部动画电影陆续公布档期。从合家欢题材到奇幻冒险，内容丰富，充分照顾了不同年龄段观众的需求。",
    "近年来，国产动画在技术层面进步明显，画面表现力有了显著提升。与此同时，创作者也越来越重视故事的普世情感，让作品能够跨越年龄界限。",
    "业内普遍认为，暑期档是动画电影最集中的时段，竞争也最为激烈。最终能够脱颖而出的，往往是在情感共鸣上做得更扎实的作品。",
    "对观众来说，这无疑是一个值得期待的夏天。",
  ],
  },
  {
    id: "n-classic-remake",
    title: "经典IP翻拍热潮下的观众期待与挑战",
    category: "行业观察",
    summary: "经典作品翻拍持续升温，如何在致敬与创新之间取得平衡，成为创作者面临的核心课题。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20vintage%20film%20reels%20and%20light%20projection%2C%20warm%20sepia%20and%20deep%20amber%20palette%2C%20minimal%20editorial%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=news-classic-remake-cover&orientation=landscape",
    author: "编辑部",
    source: "555电影网",
    date: "2026-02-22",
    views: 8890,
  paragraphs: [
    "经典 IP 的翻拍近年来热度不减。熟悉的角色与故事自带情怀滤镜，能够迅速吸引观众注意，但同时也意味着更高的期待与更严苛的比较。",
    "创作者普遍认为，翻拍的关键在于找到与当下观众的连接点。完全照搬会显得陈旧，过度改编又可能失去原作的神韵，分寸的拿捏至关重要。",
    "观众的反馈也呈现出分化。一部分人期待新版本带来新的解读，另一部分人则更愿意重温经典本身。",
    "无论结果如何，翻拍热都反映出优质内容的长久生命力。",
  ],
  },
  {
    id: "n-short-drama",
    title: "短剧市场快速扩张，内容品质成竞争核心",
    category: "行业观察",
    summary: "短剧以节奏快、门槛低的特点迅速占领市场，但在规模扩张之后，品质正在成为新的竞争焦点。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20vertical%20screens%20stacked%20in%20a%20dark%20room%20with%20warm%20glow%2C%20deep%20navy%20and%20amber%20palette%2C%20minimal%20editorial%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=news-short-drama-cover&orientation=landscape",
    author: "编辑部",
    source: "555电影网",
    date: "2026-02-15",
    views: 16040,
  paragraphs: [
    "短剧市场在过去几年迅速扩张。单集时长短、剧情节奏快、观看门槛低，让它成为许多人碎片时间的娱乐选择。",
    "然而，随着市场规模的扩大，观众的审美要求也在提高。单纯依靠爽感与套路的作品热度难以持续，剧本质量与制作水准正在成为新的分水岭。",
    "不少从业者开始尝试在短剧中融入更完整的人物弧光与现实议题，希望能够在娱乐之外带来更多思考。",
    "可以预见，短剧市场将从「跑马圈地」走向「精耕细作」。",
  ],
  },
];